import {
  Clock,
  Folder,
  Folders,
  Money,
  PalmTree,
  Present,
  Rocket,
  Schedule,
  Split,
  Suitcase,
  Timer,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { SidebarManifest } from 'modules/core/lib/manifests/types'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    // Personal group
    {
      identifier: 'onboarding',
      name: i18n.t('sidebar.onboarding'),
      factorialOneIcon: Rocket,
      path: navigation.employee_onboarding.onboardingTasks.fullPath(),
      group: 'personal',
      module: 'onboarding',
      priority: 'highest',
    },
    {
      identifier: 'employee_attendance',
      name: i18n.t('sidebar.clock_in'),
      path: navigation.clockIn.fullPath(),
      factorialOneIcon: Clock,
      group: 'personal',
      module: 'employee_attendance',
      priority: 'high',
    },
    {
      identifier: 'timeoff',
      name: i18n.t('sidebar.time_off'),
      path: navigation.timeOff.fullPath(),
      factorialOneIcon: PalmTree,
      group: 'personal',
      module: 'timeoff',
      priority: 'high',
    },
    {
      identifier: 'my_documents',
      name: i18n.t('sidebar.my_documents'),
      factorialOneIcon: Folder,
      path: navigation.documents.fullPath(),
      group: 'personal',
      module: 'my_documents',
      priority: 'medium',
    },
    {
      identifier: 'my_projects',
      name: i18n.t('sidebar.my_projects'),
      path: navigation.myProjects.fullPath(),
      factorialOneIcon: Suitcase,
      group: 'personal',
      module: 'my_projects',
      priority: 'medium',
    },
    {
      identifier: 'my_benefits',
      name: i18n.t('benefits.my_sidebar'),
      path: navigation.myBenefits.fullPath(),
      factorialOneIcon: Present,
      group: 'personal',
      module: 'my_benefits',
      priority: 'medium',
    },
    // Company group
    {
      identifier: 'company_documents',
      name: i18n.t('sidebar.documents'),
      factorialOneIcon: Folders,
      path: navigation.files.fullPath(),
      group: 'company',
      module: 'company_documents',
      priority: 'medium',
    },
    // Operations group
    {
      identifier: 'attendanceCompany',
      name: i18n.t('sidebar.time_tracking'),
      factorialOneIcon: Timer,
      path: navigation.timeTracking.list.fullPath(),
      group: 'operations',
      module: 'company_attendance',
      priority: 'highest',
    },
    {
      identifier: 'shifts',
      name: i18n.t('sidebar.shift_management'),
      factorialOneIcon: Schedule,
      path: navigation.shifts.fullPath(),
      group: 'operations',
      module: 'shift_management',
      priority: 'high',
    },
    {
      identifier: 'projects',
      name: i18n.t('sidebar.projects_management'),
      factorialOneIcon: Suitcase,
      path: navigation.projects.fullPath(),
      group: 'operations',
      module: 'company_projects',
      priority: 'medium',
    },
    {
      identifier: 'benefits',
      name: i18n.t('benefits.module_name'),
      factorialOneIcon: Present,
      path: navigation.benefits.fullPath(),
      group: 'operations',
      module: 'benefits',
      priority: 'low',
    },
    {
      identifier: 'payroll',
      name: i18n.t('sidebar.payroll_bundle'),
      factorialOneIcon: Money,
      path: navigation.payrollBundle.fullPath(),
      group: 'operations',
      module: 'payroll_bundle',
      priority: 'low',
    },
    {
      identifier: 'compensations',
      name: i18n.t('sidebar.compensation'),
      factorialOneIcon: Money,
      path: navigation.compensations.fullPath(),
      group: 'operations',
      module: 'compensations',
      priority: 'low',
    },
    // More group
    {
      identifier: 'processes',
      name: i18n.t('sidebar.processes'),
      factorialOneIcon: Split,
      path: navigation.processes.fullPath(),
      group: 'more',
      module: 'processes',
      priority: 'medium',
    },
  ]
}
